module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-f5e5627e.png";